import React from 'react';

interface LedyerLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const LedyerLogo: React.FC<LedyerLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 30"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Black background */}
        <rect
          x="0"
          y="0"
          width="100"
          height="30"
          fill="#000000"
        />
        
        {/* Ledyer text with custom E and r */}
        <g fill="#ffffff" fontFamily="Arial, sans-serif" fontWeight="bold">
          {/* L */}
          <text x="8" y="22" fontSize="18">L</text>
          
          {/* Custom E - three horizontal lines */}
          <line x1="18" y1="8" x2="25" y2="8" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
          <line x1="18" y1="15" x2="28" y2="15" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
          <line x1="18" y1="22" x2="25" y2="22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
          
          {/* d */}
          <text x="32" y="22" fontSize="18">d</text>
          
          {/* y */}
          <text x="42" y="22" fontSize="18">y</text>
          
          {/* Custom r - vertical bar with circle */}
          <line x1="58" y1="8" x2="58" y2="22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="62" cy="10" r="2" fill="#ffffff"/>
          
          {/* e */}
          <text x="70" y="22" fontSize="18">e</text>
        </g>
      </svg>
    </div>
  );
};

export default LedyerLogo;


